import { HTTP } from '@/http-common'

function getBankTransaction (bankTransactionId) {
  return HTTP.get('/bank-transactions/' + bankTransactionId)
}

function deleteBankTransaction (bankTransactionId) {
  return HTTP.delete('/bank-transactions/' + bankTransactionId)
}

function syncBankTransactions (fromDate, toDate) {
  return HTTP.get('/bank-transactions/sync?from_date=' + fromDate + '&to_date=' + toDate)
}

function syncRegistryBankTransactions () {
  return HTTP.get('/bank-transactions/sync-registry')
}

function recognizeBankTransactions (fromDate, toDate) {
  return HTTP.get('/bank-transactions/recognize?from_date=' + fromDate + '&to_date=' + toDate)
}

function bindToClient (bankTransactionId, clientId) {
  let data = JSON.stringify({client: clientId})

  return HTTP.post('/bank-transactions/' + bankTransactionId + '/bind-to-client', data, {
    headers: {
      'Content-Type': 'application/json; charset=utf-8'
    }
  })
}

export {
  getBankTransaction,
  deleteBankTransaction,
  syncBankTransactions,
  syncRegistryBankTransactions,
  recognizeBankTransactions,
  bindToClient
}



// WEBPACK FOOTER //
// ./src/services/bank_transaction.service.js